import { PayoutModel } from "./PayoutModel";
import { ReferredOrderModel } from "./ReferredOrderModel";

export class Dashboard{
    public TotalEarnings:number = 0;
    public  TotalReferrals:number = 0;
    public  ThisMonthEarnings:number = 0;

    public Payouts:PayoutModel[] = [];
    public ReferredOrders:ReferredOrderModel[] = [];

    constructor(init?:Partial<Dashboard>){
        Object.assign(this, init);
    }
}